// OneNote desktop's "Copy Link to Page" puts two links on the clipboard, one per line:
// the web link (https://.../Doc.aspx?sourcedoc=...) and its onenote: app link. A
// single-line input turns the line break into a space, and the joined value fails URL
// validation even though each half is a valid link on its own.
//
// Keep the web link: it opens in a browser, in Teams and for readers without the
// OneNote desktop app, where the onenote: link does nothing. Anything that is not
// several links joined by whitespace is returned trimmed and otherwise untouched.
export const normalizePastedLink = (value: string): string => {
  const trimmed = value.trim();
  const links = trimmed.split(/\s+(?=(?:onenote:)?https?:\/\/)/i);
  if (links.length < 2) return trimmed;
  return links.find(link => /^https?:\/\//i.test(link)) ?? links[0];
};
